import { Popup } from '@creditsights/styleguide-web';
import React from 'react';
import styles from './AssetTooltip.module.scss';
import { AssetClass } from '../../types';

interface AssetTooltipProps {
  assetClass?: AssetClass;
  children: React.ReactElement;
}

const AssetTooltip = ({ children, assetClass }: AssetTooltipProps): React.ReactElement => {
  let attachmentsTooltip: React.ReactElement;

  if (assetClass === 'loan') {
    attachmentsTooltip = (
      <div>
        <div>Please attach:</div>
        <ul>
          <li>
            Credit Agreement, Term Sheet, Cover Amendment, Exhibits to Amendment; for secondary requests, please submit
            the final, executed versions of all documents
          </li>
          <li>Lender Presentation / CIM / Management’s Cap Table</li>
          <li>Any other documents that will help us answer your questions</li>
        </ul>
      </div>
    );
  } else if (assetClass === 'bond') {
    attachmentsTooltip = (
      <div>
        <div>Please attach:</div>
        <ul>
          <li>
            OM, indenture, supplemental indentures; for secondary requests, please submit the final, executed versions
            of all documents
          </li>
          <li>Any other documents that will help us answer your questions</li>
        </ul>
      </div>
    );
  } else if (assetClass === 'other') {
    attachmentsTooltip = (
      <div>
        <div>Please attach:</div>
        <ul>
          <li>Any documents that will help us answer your questions</li>
        </ul>
      </div>
    );
  } else {
    return children;
  }

  return (
    <Popup
      className={styles.assetTooltip}
      style={{ zIndex: 50 }}
      position="top center"
      basic={false}
      offset={[0, 7]}
      wide
      trigger={children}
    >
      {attachmentsTooltip}
    </Popup>
  );
};

export default AssetTooltip;
